import React from 'react';

export const pageMeta = {
  "name": "JS 2019",
  "link": "/javascript/versions/2019"
};

export default function JavascriptVersions2019() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS 2019</h2>
      <p>Route: /javascript/versions/2019</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
